<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-start me-auto">
  <li class="nav-item d-none d-lg-block">
    <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
      href="javascript:void(0)">
      <i [class]="sidebarExpanded ? 'ti-angle-left' : 'ti-menu'"></i>
    </a>
  </li>
</ul>
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-end">
  <!-- Language dropdown - only show for dev users -->
  @if(isDevUser()) {
  <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
    <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" role="button"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="flag-icon flag-icon-{{ selectedLanguage.icon }}"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown" ngbDropdownMenu>
      @for(lang of languages; track lang) {
      <span class="dropdown-item" role="button" tabindex="0" (click)="changeLanguage(lang)"
        (keydown.enter)="changeLanguage(lang)" (keydown.space)="changeLanguage(lang)">
        <i class="flag-icon flag-icon-{{ lang.icon }}"></i>
        <span>{{ lang.language }}
          @if(lang.type) {
          <span>({{ lang.type }})</span>
          }

        </span>
      </span>
      }

    </div>
  </li>

  <!-- Search - only show for dev users -->
  <li class="nav-item search-box">
    <a (click)="showSearch = !showSearch" class="nav-link waves-effect waves-dark" href="javascript:void(0)">
      <i class="ti-search"></i>
    </a>
    <form class="app-search position-absolute" [ngClass]="{ 'show-search': showSearch }">
      <input type="text" class="form-control" placeholder="Search &amp; enter" />
      <a class="srh-btn" href="javascript:void(0)" (click)="showSearch = !showSearch">
        <i class="ti-close"></i>
      </a>
    </form>
  </li>
  <!-- Comment - only show for dev users -->
  <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
    <a ngbDropdownToggle class="nav-link dropdown-toggle waves-effect waves-dark" href="javascript:void(0)"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="mdi mdi-message"></i>
      <div class="notify">
        <span class="heartbit"></span> <span class="point"></span>
      </div>
    </a>
    <div class="dropdown-menu mailbox dropdown-menu-end dropdown-menu-animate-up" ngbDropdownMenu>
      <span class="with-arrow">
        <span class="bg-primary"></span>
      </span>
      <ul class="list-style-none">
        <li>
          <div class="drop-title bg-primary text-white">
            <h4 class="mb-0 mt-1 text-white">4 New</h4>
            <span class="fw-light">Notifications</span>
          </div>
        </li>
        <li>
          <ng-scrollbar class="message-center notifications">
            <!-- Message -->
            @for(notification of notifications; track notification) {
            <a href="javascript:void(0)" class="message-item border-bottom d-block text-decoration-none">
              <span class="btn btn-circle rounded-circle {{ notification.btn }}">
                <i class="{{ notification.icon }}"></i>
              </span>
              <span class="mail-contnet d-inline-block w-75 ps-3 align-middle">
                <h5 class="message-title">{{ notification.title }}</h5>
                <span class="mail-desc fs-2 d-block text-muted text-truncate">{{
                  notification.subject
                  }}</span>
                <span class="time fs-2 d-block text-muted text-truncate">{{
                  notification.time
                  }}</span>
              </span>
            </a>
            }

          </ng-scrollbar>
        </li>
        <li class="border-top p-3 d-grid">
          <button class="btn btn-info">Check all notifications</button>
        </li>
      </ul>
    </div>
  </li>
  <!-- Messages - only show for dev users -->
  <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
    <a ngbDropdownToggle class="nav-link dropdown-toggle waves-effect waves-dark" href="javascript:void(0)" id="2"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="mdi mdi-email"></i>
      <div class="notify">
        <span class="heartbit"></span> <span class="point"></span>
      </div>
    </a>
    <div class="dropdown-menu dropdown-menu-end mailbox dropdown-menu-animate-up" aria-labelledby="2" ngbDropdownMenu>
      <span class="with-arrow">
        <span class="bg-danger"></span>
      </span>
      <ul class="list-style-none">
        <li>
          <div class="drop-title text-white bg-danger">
            <h4 class="mb-0 mt-1 text-white">5 New</h4>
            <span class="fw-light">Messages</span>
          </div>
        </li>
        <li>
          <ng-scrollbar class="message-center message-body">
            <!-- Message -->
            @for(mymessage of mymessages; track mymessage) {
            <a href="javascript:void(0)" class="message-item border-bottom d-block text-decoration-none">
              <span class="user-img position-relative d-inline-block">
                <img src="{{ mymessage.useravatar }}" alt="user" class="rounded-circle" />
                <span class="profile-status rounded-circle d-inline-block {{
                    mymessage.status
                  }} float-end"></span>
              </span>
              <span class="mail-contnet d-inline-block w-75 ps-3 align-middle">
                <h5 class="message-title">{{ mymessage.from }}</h5>
                <span class="mail-desc fs-2 d-block text-muted text-truncate">{{
                  mymessage.subject
                  }}</span>
                <span class="time fs-2 d-block text-muted text-truncate">{{
                  mymessage.time
                  }}</span>
              </span>
            </a>
            }

          </ng-scrollbar>
        </li>
        <li>
          <a class="
              text-center
              link
              d-flex
              align-items-center
              justify-content-center
            " href="javascript:void(0);">
            <b>See all e-Mails</b>
            <i class="fa fa-angle-right ms-1"></i>
          </a>
        </li>
      </ul>
    </div>
  </li>
  <!-- Mega menu - only show for dev users -->
  <li class="nav-item mega-dropdown" ngbDropdown [autoClose]="false">
    <a ngbDropdownToggle class="nav-link waves-effect waves-dark" href="javascript:void(0)" data-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false">
      <i class="mdi mdi-view-grid"></i>
    </a>
    <div class="dropdown-menu" ngbDropdownMenu>
      <div class="mega-dropdown-menu row">
        <div class="col-lg-3 col-xlg-2 mb-4">
          <h4 class="mb-4">CAROUSEL</h4>
          <!-- CAROUSEL -->
          <ngb-carousel class="carousel-dark">
            <ng-template ngbSlide>
              <img src="assets/images/big/img1.jpg" class="img-fluid" alt="Random first slide" />
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/images/big/img2.jpg" class="img-fluid" alt="Random second slide" />
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/images/big/img3.jpg" class="img-fluid" alt="Random third slide" />
            </ng-template>
          </ngb-carousel>
          <!-- End CAROUSEL -->
        </div>
        <div class="col-lg-3 mb-4">
          <h4 class="mb-4">ACCORDION</h4>
          <!-- Accordian -->
          <div ngbAccordion>
            <div ngbAccordionItem [collapsed]="false">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>Simple</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
                    wolf moon
                    officia aute.
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  <span>&#9733; <b>Fancy</b> title &#9733;</span>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
                    wolf moon
                    officia aute.
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem [disabled]="true">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>Disabled</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
                    wolf moon
                    officia aute.
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mb-4">
          <h4 class="mb-4">CONTACT US</h4>
          <!-- Contact -->
          <form>
            <div class="mb-3">
              <input type="text" class="form-control" id="exampleInputname1" placeholder="Enter Name" />
            </div>
            <div class="mb-3">
              <input type="email" class="form-control" placeholder="Enter email" />
            </div>
            <div class="mb-3">
              <textarea class="form-control" id="exampleTextarea" rows="3" placeholder="Message"></textarea>
            </div>
            <button type="submit" class="btn btn-info">Submit</button>
          </form>
        </div>
        <div class="col-lg-3 col-xlg-4 mb-4">
          <h4 class="mb-4">List style</h4>
          <!-- List style -->
          <ul class="list-style-none">
            <li>
              <a href="javascript:void(0)">
                <i class="fa fa-check text-success"></i> You can give link</a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="fa fa-check text-success"></i> Give link</a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="fa fa-check text-success"></i> Another Give link</a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="fa fa-check text-success"></i> Forth link</a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="fa fa-check text-success"></i> Another fifth link</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  }
  <!-- Global Reporting Entity Filter - only for internal users -->
  @if(canUseGlobalFilter) {
  <li class="nav-item" ngbDropdown placement="bottom-end">
    <a ngbDropdownToggle class="nav-link waves-effect waves-dark global-filter-toggle" href="javascript:void(0)"
      [class.global-filter-active]="globalFilter">
      <i class="mdi mdi-filter-outline me-1"></i>
      <span class="global-filter-label d-none d-md-inline">
        @if(globalFilter) {
          {{ globalFilter.reportingEntityName }}
        } @else {
          All Reporting Entities
        }
      </span>
      @if(globalFilter) {
        <span class="global-filter-badge ms-1">
          <i class="mdi mdi-filter-check"></i>
        </span>
      }
    </a>
    <div class="dropdown-menu dropdown-menu-end global-filter-dropdown" ngbDropdownMenu>
      <div class="global-filter-header px-3 py-2">
        <strong>Global Reporting Entity Filter</strong>
      </div>
      <div class="dropdown-divider mt-0"></div>
      <button ngbDropdownItem
        [class.active]="!globalFilter"
        (click)="clearGlobalFilter()">
        All Reporting Entities
      </button>
      <div class="dropdown-divider"></div>
      @for(re of reportingEntities; track re.id) {
        <button ngbDropdownItem
          [class.active]="globalFilter?.reportingEntityId === re.id"
          (click)="selectGlobalReportingEntity(re)">
          {{ re.name }}
        </button>
      }
    </div>
  </li>
  }
  <!-- User profile and search -->
  <li class="nav-item" ngbDropdown placement="bottom-end">
    <a ngbDropdownToggle class="nav-link text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <img src="assets/images/users/user1.jpg" alt="user" class="rounded-circle" width="31" />
    </a>
    <div class="dropdown-menu-right user-dd" ngbDropdownMenu>
      <div class="d-flex no-block align-items-center p-3 mb-2">
        <div class="">
          <img src="assets/images/users/user1.jpg" alt="user" class="rounded" width="70" />
        </div>
        <div class="ms-2">
          <h4 class="mb-0 fs-4">{{ getCurrentUser()?.firstName || '' }} {{ getCurrentUser()?.lastName || '' }}</h4>
          <p class="text-muted mb-0 fs-2">{{ getCurrentUser()?.email || '' }}</p>
          @if(isDevUser()) {
          <a href="javascript:void(0)" class="btn btn-danger btn-rounded btn-sm mt-1">View Profile</a>
          }
        </div>
      </div>
      <a class="dropdown-item" href="/profile">
        <i class="ti-user me-1 ms-1"></i> My Profile</a>
      @if(isDevUser()) {
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-wallet me-1 ms-1"></i> My Balance</a>
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-email me-1 ms-1"></i> Inbox</a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript:void(0)">
        <i class="ti-settings me-1 ms-1"></i> Account Setting</a>
      <div class="dropdown-divider"></div>
      }
      <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">
        <i class="fa fa-sign-out-alt me-1 ms-1"></i> Logout</a>
    </div>
  </li>
</ul>
